import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "the-header",
  key: "the-header"
}
const _hoisted_2 = { class: "title" }

import { ref } from 'vue';
import { useContextMenu } from '@/utils/hooks/context-menu';
import { useAccountStore } from '@/stores/account';
import { useRouter } from 'vue-router';
import { useDialogStore } from '@/stores/dialogs';
import { useUiStore } from '@/stores/ui';
import BillingInfoDialog from './dialogs/BillingInfoDialog.vue';
import VIconButton from './VIconButton.vue';
import BellIcon from './icons/other/BellIcon.vue';
import UserIcon from './icons/other/UserIcon.vue';
import VContextMenu from './VContextMenu.vue';
import SettingsIcon from './icons/other/SettingsIcon.vue';
import BillingIcon from './icons/other/BillingIcon.vue';
import LogoutIcon from './icons/navigation/LogoutIcon.vue';
import SettingsDialog from './dialogs/SettingsDialog.vue';
import MenuIcon from './icons/other/MenuIcon.vue'
import Notifications from './Notifications.vue';
import ConnectNowHeader from '@/components/ConnectNowHeader.vue';
import ReachedLimitActionsHeader from '@/components/ReachedLimitActionsHeader.vue';
import FacebookAlertHeader from './FacebookAlertHeader.vue';
import PageErrorsHeader from './PageErrorsHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: string }



const router = useRouter()
const account = useAccountStore()

const logout = () => {
  account.logout()
  router.push("/auth")
}

const dialogStore = useDialogStore()

const contextMenu = useContextMenu([
  { title: "Settings", icon: SettingsIcon, onClick: () => dialogStore.open(SettingsDialog) },
  { title: "Billing", icon: BillingIcon, onClick: () => dialogStore.open(BillingInfoDialog) },
  { title: "Log Out", class: "red", icon: LogoutIcon, onClick: logout }
], { contentOrigin: "top right", anchorOrigin: "bottom right" })

const uiStore = useUiStore()

const notificationRef = ref<any>()
const openNotifications = (e: MouseEvent) => {
  notificationRef.value!.open(e)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
      _createVNode(VIconButton, { onClick: openNotifications }, {
        default: _withCtx(() => [
          _createVNode(BellIcon)
        ]),
        _: 1
      }),
      _createVNode(VIconButton, _mergeProps({
        class: ["on-desktop", { active: _unref(contextMenu).props.show }]
      }, _toHandlers(_unref(contextMenu).hoverEmits)), {
        default: _withCtx(() => [
          _createVNode(UserIcon)
        ]),
        _: 1
      }, 16, ["class"]),
      _createVNode(VIconButton, {
        class: "on-mobile ml-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).mobileMenu = true))
      }, {
        default: _withCtx(() => [
          _createVNode(MenuIcon)
        ]),
        _: 1
      }),
      _createVNode(VContextMenu, { menu: _unref(contextMenu) }, null, 8, ["menu"]),
      _createVNode(Notifications, {
        ref_key: "notificationRef",
        ref: notificationRef
      }, null, 512)
    ]),
    _createVNode(ReachedLimitActionsHeader),
    _createVNode(FacebookAlertHeader)
  ], 64))
}
}

})